/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mentorexchangelanguage2Inputs */

const en__field_mentorexchangelanguage2 = /** @type {(inputs: _Field_Mentorexchangelanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In which language do you want to communicate?`)
};

const de__field_mentorexchangelanguage2 = /** @type {(inputs: _Field_Mentorexchangelanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welcher Sprache möchtest du mit deinem Mentor/ deiner Mentorin sprechen?`)
};

/**
* | output |
* | --- |
* | "In which language do you want to communicate?" |
*
* @param {_Field_Mentorexchangelanguage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_mentorexchangelanguage2 = /** @type {((inputs?: _Field_Mentorexchangelanguage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mentorexchangelanguage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentorexchangelanguage2(inputs)
	return de__field_mentorexchangelanguage2(inputs)
});
export { _field_mentorexchangelanguage2 as "_field_mentorExchangeLanguage" }